import { Formik, FormikHelpers } from "formik";
import {
  ControlcenterMelcoModelsMachineLicense,
  useFormSubmit,
} from "melco-shared-logic";

import { useQueryClient } from "react-query";
import { useState } from "react";
import { DirtyFormPrompt } from "../../../../form/DirtyFormPrompt";
import { DisplayCreateMachineLicensesForm } from "./DisplayCreateMachineLicensesForm";
import { useCreateMachineLicensesManager } from "../../../../../hooks/machineLicenses/useCreateMachineLicensesManager";

export type CreateMachineLicensesFormValueType = {
  product_code: string;
  sub_type: string;
  //referral_code: string;
  //version_id: string; // will be use to create the License
  email_address: string;
  // version_number?: string; // will be used to fetch subscriptions code that need product code and version number
  // assign_license?: boolean;
  language?: string | null;
  melco_customer_id?: string | null;
  sub_started_on?: Date | null;
  license_key?: string | null;
  number_of_machines: number;
};

type CreateMachineLicensesFormProps = {
  machineLicensesFormValues?: CreateMachineLicensesFormValueType;
  machineLicensesDisplayValues: any;
  onCreateMachineLicensesCallBackFn: (
    obj: CreateMachineLicensesFormValueType,
    displayValues: any
  ) => any;
};

export const CreateMachineLicensesForm: React.FC<
  CreateMachineLicensesFormProps
> = ({
  machineLicensesDisplayValues,
  machineLicensesFormValues,
  onCreateMachineLicensesCallBackFn,
}) => {
    const queryClient = useQueryClient();
    const queryKey = "createlicensemanage";
    const licenseManager = useCreateMachineLicensesManager();
    const [displayValues, setDisplayValues] = useState<any>();
    const onSubmit = async (
      values: CreateMachineLicensesFormValueType,
      formikHelpers: FormikHelpers<CreateMachineLicensesFormValueType>
    ) => {
      await onCreateSerialNumber(values, formikHelpers, {
        isManuallyResettingForm: true,
      });
    };

    const createMachineLicensesFormToInitialValues = (
      formvalues: CreateMachineLicensesFormValueType
    ) => {
      const {
        email_address,
        // version_number,
        // version_id,

        sub_type,
        // assign_license,
        language,
        melco_customer_id,
        sub_started_on,

        number_of_machines,
      } = formvalues;

      const initialValues: CreateMachineLicensesFormValueType = {
        product_code: "SUMMIT_MANAGER",
        sub_type: sub_type ?? "",
        //  version_number: version_number ?? "",
        license_key: "",
        number_of_machines: number_of_machines ?? 0,
        //version_id: version_id ?? "",
        email_address: email_address ?? "",
        // assign_license: assign_license ?? false,
        language: language ?? "",
        melco_customer_id: melco_customer_id ?? "",
        sub_started_on: sub_started_on ?? null,
      };

      return initialValues;
    };

    const initialValues: CreateMachineLicensesFormValueType = {
      product_code: "SUMMIT_MANAGER",
      sub_type: machineLicensesFormValues?.sub_type ?? "",
      //version_number: machineLicensesFormValues?.version_number ?? "",
      // version_id: machineLicensesFormValues?.version_id ?? "",
      email_address: machineLicensesFormValues?.email_address ?? "",
      // assign_license: machineLicensesFormValues?.assign_license ?? false,
      language: machineLicensesFormValues?.language ?? "",
      melco_customer_id: machineLicensesFormValues?.melco_customer_id ?? "",
      sub_started_on: machineLicensesFormValues?.sub_started_on ?? null,
      license_key: machineLicensesFormValues?.license_key ?? "",
      number_of_machines: machineLicensesFormValues?.number_of_machines ?? 0,
    };

    const handleCreateMachineLicenses = async (
      values: CreateMachineLicensesFormValueType,
      formikHelpers: FormikHelpers<CreateMachineLicensesFormValueType>,
      options: {}
    ) => {
      //setOpenAskConfirmationBoxTrigger(!openAskConirmationBoxTrigger)
      /**
       * As per requirement by default we have to show Don't assign license switch button off in UI
       * but for backend we have to send true value for it.
       * so we will flip the value , whatever is shown in UI
       * if switch button off then send true
       * if switch button on then send false
       */
      let newEntity:
        | ControlcenterMelcoModelsMachineLicense
        | undefined = await licenseManager({
          email_address: values.email_address,
          license_key: values.license_key,
          number_of_machines: values.number_of_machines,
          product_code: "SUMMIT_MANAGER", //values.product_code,
          sub_type: values.sub_type,

          is_validate_only: true,
          language: values.language,
          melco_customer_id: values.melco_customer_id,
          sub_started_on: values.sub_started_on,
        });
      //   //console.log("newEntity",newEntity)
      console.log("[Debug] Subscription cost", newEntity?.subscription_cost);
      const updatedDisplayValues = {
        ...displayValues,
        ...newEntity,
      };
      setDisplayValues(updatedDisplayValues);

      // setDisplayValues((prevValues: any) => ({
      //   ...prevValues,
      //   subscription_cost: newEntity?.subscription_cost ?? 0,
      // }));
      console.log("ADD NEW ENTITy", newEntity);
      //let newEntity = null;
      formikHelpers.resetForm({
        values: createMachineLicensesFormToInitialValues(
          newEntity
            ? {
              product_code: newEntity?.product_code ?? "",
              //        "referral_code": "LICENSE_MANAGER",
              license_key: newEntity?.license_key ?? "",
              number_of_machines: newEntity?.number_of_machines ?? 0,
              sub_type: newEntity?.sub_type ?? "",
              //  "version_number": newEntity?.version_number ?? "",
              //  version_id: "",
              email_address: newEntity?.email_address ?? "",
              //"assign_license": newEntity?.assign_license ?? true,
              language: newEntity?.language ?? "",
              //            melco_customer_id: newEntity?.melco_customer_id ?? "",
              sub_started_on: newEntity?.sub_started_on ?? null,
            }
            : {
              product_code: "",
              //        "referral_code": "LICENSE_MANAGER",
              sub_type: "",
              //version_number: "",
              // version_id: "",
              email_address: "",
              //assign_license: false,
              language: "",
              melco_customer_id: "",
              sub_started_on: null,
              license_key: "",
              number_of_machines: 0,
            }
        ),
      });
      //queryClient.setQueryData(queryKey, newEntity);
      //onCloseDrawer(false);
      /**
       * Take original values so use values on summary page after click on Next button
       */
      let tempLicenseFormValues: CreateMachineLicensesFormValueType = {
        email_address: values.email_address,
        product_code: values.product_code,
        sub_type: values.sub_type,
        // version_id: values.version_id,
        // version_number: displayValues?.version_number_label ?? "",
        //assign_license: values?.assign_license,
        language: values?.language,
        melco_customer_id: values?.melco_customer_id,
        sub_started_on: values?.sub_started_on,
        number_of_machines: values.number_of_machines,
        license_key: values.license_key,
      };

      console.log("[debug] displayValues", updatedDisplayValues);
      onCreateMachineLicensesCallBackFn(
        tempLicenseFormValues,
        updatedDisplayValues
      );
    };

    const formSubmitToCreateMachineLicenses = () => {
      return [
        async (
          values: CreateMachineLicensesFormValueType,
          formikHelpers: FormikHelpers<CreateMachineLicensesFormValueType>
        ) => {
          return handleCreateMachineLicenses(values, formikHelpers, {});
        },
        {
          //  translationPrefix: "licenses.basic.detail.Create",
          // translationOptions: {
          //   batchnumber: 1,
          //        },
          translationPrefix: ["licenses.basic.detail", "create"].join("."),
          onError: () => {
            // refetch entity from server
            queryClient.invalidateQueries(queryKey);
          },
        },
      ] as const;
    };

    const onCreateSerialNumber = useFormSubmit(
      ...formSubmitToCreateMachineLicenses()
    );

    const callback = (v: any) => {
      console.log(v);
      setDisplayValues(v);
    };

    return (
      <>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize
        >
          <DirtyFormPrompt>
            <DisplayCreateMachineLicensesForm
              machineLicensesFormValues={machineLicensesFormValues}
              machineLicensesDisplayValues={machineLicensesDisplayValues}
              callback={callback}
            // onCloseDrawer={onCloseDrawer}
            />
          </DirtyFormPrompt>
        </Formik>
      </>
    );
  };
